import { clsx } from 'clsx';

import styles from './Group.css';

interface IFilterProps {
  className?: string;
  isRedesign?: boolean;
}

export const Group: React.FC<React.PropsWithChildren<IFilterProps>> = props => {
  const className = clsx(props.isRedesign ? styles['redesigned-container'] : styles['container'], props.className);

  return <div className={className}>{props.children}</div>;
};
